import { ApiClient } from './';
import { HomeArtifacts } from './api-types/artifacts';

export class ArtifactsApi extends ApiClient {
  getHome() {
    return this.requestGet<HomeArtifacts>('Home/artifactsCounts');
  }
}
